module.exports = __webpack_public_path__ + "img/1.4d61c777.png";